export default __webpack_public_path__ + "94db794cf2ee67a3e96382ccb5b7f69a.svg";